
  // ---------testimonial -------------

  $('.wrapper-main-testimonial  .testimonial-upper-block').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  arrow:true,
  cssEase: 'linear',
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
// ----------mega menu hover------------
const menuItems = document.querySelectorAll('.list-menu.list-menu--inline li');
menuItems.forEach(item => {
  const megaMenu = item.querySelector('.mega-menu');
  if (!megaMenu) return; // skip if no mega menu inside this item
  item.addEventListener('mouseenter', () => {
    megaMenu.setAttribute('open', '');
  });
  item.addEventListener('mouseleave', () => {
    megaMenu.removeAttribute('open');
  });
  megaMenu.addEventListener('mouseleave', () => {
    megaMenu.removeAttribute('open');
  });
});

// ----------card products------
function product_wrap(element) {
  element.parentElement.querySelectorAll('.option-wrap-value').forEach(el => el.classList.remove('active-val'));
  element.classList.add('active-val');
  const parent = element.closest('.main-product-inner-content');
  var top_parent = element.closest('.card__content');
  const wrapper = parent.parentElement; 
let active_values = '';
if (parent) {
  parent.querySelectorAll('.option-wrap-value.active-val').forEach(activeOption => {
    const valueName = activeOption.getAttribute('value_name');
    if (valueName) {
      active_values += valueName;
    }
  });
}
 const combinedTitle = active_values.trim()
  const matchedVariant = parent.querySelector(`.variant-ds-none .variant-pdp[data-variant-title="${combinedTitle}"]`);
  const productForm = wrapper.querySelector('.pdp-wrapper-btn');
  var wrapper_top_parent = top_parent.parentElement.querySelector('.image-with-popup').querySelector('.media.media--transparent.media--hover-effect img');
  const variantInput = productForm?.querySelector('.product-variant-id');
  const cartBtn = productForm?.querySelector('.quick-add__submit.button.button--full-width.button--secondary span');
  const atc_button = productForm?.querySelector('.quick-add__submit.button.button--full-width.button--secondary');

  if (matchedVariant) {
    const variantID = matchedVariant.getAttribute('data-variant-id');
    var data_img = matchedVariant.getAttribute('data-variant-img');
    console.log(data_img);
    if( data_img != '//www.zenzenco.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12.gif')
    {
      wrapper_top_parent.setAttribute('srcset', data_img);
    }
    const isSoldOut = matchedVariant.classList.contains('sold-out');
    if (variantInput) variantInput.setAttribute('value', variantID);
    if (isSoldOut) {
            if (cartBtn) {
        atc_button.disabled = true;
        cartBtn.textContent = 'Sold out';
        cartBtn.classList.add('sold-out-btn');
      }
    } else {
      if (cartBtn) {
        atc_button.disabled = false;
        cartBtn.textContent = 'Add to cart';
        cartBtn.classList.remove('sold-out-btn');
      }
    }
  } else {
  }
}


$('#size-guide .checkbox').click(function() {
  var value = $('#size-guide .checkbox').val();
  if(value == 'cm')
  {
     $('#size-guide .checkbox').val('in');
    $('.inch-table').hide();
    $('.cm-table').show();
   
  }else
     {
    $('#size-guide .checkbox').val('cm');
    $('.cm-table').hide();
    $('.inch-table').show();
  }
});

// ----------faq page------

$('.accordion details').on('click', function () {
  const $clicked = $(this);
    $clicked.closest('.grid__item')
          .find('.accordion details')
          .not($clicked)
          .removeAttr('open');
});
// ------------click sticky atc-----------
$(document).on('click', '#md-sticky-atc .button.product-form__submit.button', function (e) {
  e.preventDefault();
  var wrap_id = $('.product-variant-id').attr('value'); // get variant ID
  var quantity = $('.price-per-item__container .quantity__input').val();
  $('body').addClass('loading');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: wrap_id,
      quantity: quantity
    },
    dataType: 'json',
    success: function (data) {
      refreshCartDrawer();
    document.body.classList.add('js-drawer-open', 'overflow-hidden');
                document.querySelector('cart-drawer')?.classList.add('active tds');
                
    },
    error: function (xhr, status, error) {
      $('body').removeClass('loading');
    }
  });
});
function refreshCartDrawer() {
  fetch('/?sections=cart-drawer,cart-icon-bubble')
    .then(res => res.json())
    .then(data => {
      // ----- Update Cart Drawer -----
      const parser = new DOMParser();
      const doc = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newDrawer = doc.querySelector('#CartDrawer');
      const currentDrawer = document.querySelector('#CartDrawer');

      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      // ----- Update Cart Icon Bubble -----
      const newBubble = data['cart-icon-bubble'];
      const currentBubble = document.querySelector('cart-icon-bubble');

      if (currentBubble && newBubble) {
        currentBubble.outerHTML = newBubble;
      }

      // ----- Open Drawer -----
      document.body.classList.add('overflow-hidden');
      document.querySelector('cart-drawer').classList.add('active');
      document.querySelector('cart-drawer').classList.remove('is-empty');
    })
    .catch(err => console.error('Cart drawer refresh error:', err));
}

// -------------onload pdp variant--------
window.onload = function() {
   setTimeout(function() {
  $('#custom-pagination button.page-btn.active').trigger('click');
  },1000);
$('.refer-and-friend-wrap button.button_primary').click(function(){
  $('.slp_6434b9.slp_ba31b4').trigger('click');
});
// -------conversion chat-------------------
setTimeout(function() {
$('.sb-chat .sb-scroll-area .sb-header .sb-dashboard-btn').click(function(){
    $('.sb-active .sb-chat-btn .sb-close').trigger('click');
});
},3000);
$('.product-card-wrapper .custom-popup').click(function() {
    setTimeout(function() {
$('.coll-wrapper').click(function() {
    $(this).toggleClass('active');
    $(this).next('.coll-wrapper-content').stop(true, true).slideToggle(300);
  });
  // ---------------toggle-size chart--------------
  $('#size-guide .checkbox').click(function() {
  var value = $('#size-guide .checkbox').val();
  if(value == 'cm')
  {
     $('#size-guide .checkbox').val('in');
    $('.inch-table').hide();
    $('.cm-table').show();
   
  }else
     {
    $('#size-guide .checkbox').val('cm');
    $('.cm-table').hide();
    $('.inch-table').show();
  }
});
    },2000);
});

}
